export const TOUCH_LICENSE_PLATE_FIELDS = 'TOUCH_LICENSE_PLATE_FIELDS';
export const CHANGE_LICENSE_PLATE_VALUE = 'CHANGE_LICENSE_PLATE_VALUE';
export const CHANGE_IS_LOADING = 'CHANGE_IS_LOADING';
export const SET_LICENSE_PLATE_TO_RED = 'SET_LICENSE_PLATE_TO_RED';
export const SET_LICENSE_PLATE_CONFIGURATION = 'SET_LICENSE_PLATE_CONFIGURATION';
export const CHANGE_IS_RECAPTCHA_VERIFIED = 'CHANGE_IS_RECAPTCHA_VERIFIED';
